import {ProductOptionsProvider} from '@shopify/hydrogen';
import type {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import type {
  ProductWithNodes,
  SanityProductPage,
  SanitySettings,
} from '../../types';
import ProductGallery from './gallery/Gallery.client';
import MobileProductGallery from './gallery/MobileGallery.client';
import ProductWidget from './Widget.client';

type Props = {
  initialVariantId?: ProductVariant['id'];
  sanityProduct: SanityProductPage;
  storefrontProduct: ProductWithNodes;
  settings?: SanitySettings;
};

export default function ProductDetails({
  initialVariantId,
  sanityProduct,
  storefrontProduct,
  settings,
}: Props) {
  return (
    <ProductOptionsProvider
      data={storefrontProduct}
      initialVariantId={initialVariantId}
    >
      <div className={clsx('grid gap-1 pt-16 md:grid-cols-2 md:pt-0')}>
        {/* Gallery */}
        <MobileProductGallery storefrontProduct={storefrontProduct} />
        <ProductGallery storefrontProduct={storefrontProduct} />

        {/* Widget (desktop) */}
        <div className={clsx('pointer-events-none z-10 max-sm:mb-8')}>
          <div className="sticky top-[67px] mx-auto max-w-[64rem]">
            <ProductWidget
              sanityProduct={sanityProduct}
              storefrontProduct={storefrontProduct}
              settings={settings}
            />
          </div>
        </div>
      </div>
    </ProductOptionsProvider>
  );
}
